import React, { useState } from 'react'
import { IconMaps } from '@ow/icons'
import { StyledRichLineHeight } from '../styled/index'
import { toggleBlock } from '../utils/util'
import Tooltip from '../../tooltip'

const FontLineHeight = function ({ editor }) {
  const lineHeightData = ['1.0', '1.5', '2.0', '2.5', '3.0']
  const [isShow, setShow] = useState(false)
  return (
    <Tooltip
      className="bg-primary-50"
      trigger={
        <span className="relative">
          <div
            onClick={() => {
              setShow(!isShow)
            }}
          >
            <IconMaps
              type="fontLineHeight"
              width={18}
              height={18}
              fill="dark"
            />
          </div>
          {isShow && (
            <StyledRichLineHeight className="absolute">
              {lineHeightData.map((data) => {
                return (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setShow(false)
                      toggleBlock(editor, 'line-height', data)
                    }}
                  >
                    {data}
                  </div>
                )
              })}
            </StyledRichLineHeight>
          )}
        </span>
      }
      position="bottom"
      on={['hover']}
    >
      <span>行高</span>
    </Tooltip>
  )
}
export default FontLineHeight
